import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { PROVERBS } from "@/data";

export default function LoadingScreen({ onDone }) {
  const [i, setI] = useState(0);

  useEffect(() => {
    const rotate = setInterval(() => setI((v) => (v + 1) % PROVERBS.length), 1300);
    const done = setTimeout(onDone, 2700);
    return () => {
      clearInterval(rotate);
      clearTimeout(done);
    };
  }, [onDone]);

  return (
    <motion.div
      className="wv-hero-bg fixed inset-0 z-[200] flex flex-col items-center justify-center"
      initial={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.6 }}
      data-testid="loading-screen"
    >
      <div className="wv-grain" />
      <motion.div
        className="font-display text-2xl tracking-[0.4em] text-white sm:text-4xl"
        animate={{ opacity: [0.45, 1, 0.45] }}
        transition={{ duration: 2, repeat: Infinity }}
      >
        WEBTOONVERSE
      </motion.div>
      <div className="mt-9 h-px w-44 overflow-hidden bg-white/10">
        <motion.div
          className="h-full w-1/2 bg-[#FF2A6D]"
          animate={{ x: ["-100%", "300%"] }}
          transition={{ duration: 1.2, repeat: Infinity, ease: "easeInOut" }}
        />
      </div>
      <AnimatePresence mode="wait">
        <motion.p
          key={i}
          className="kr mt-9 max-w-md px-6 text-center text-sm text-white/60"
          initial={{ opacity: 0, y: 8 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -8 }}
          transition={{ duration: 0.4 }}
        >
          {PROVERBS[i]}
        </motion.p>
      </AnimatePresence>
    </motion.div>
  );
}
